import {MonsterType} from "@/characters/model/MonsterType";
import {CharacterClasses} from "@/characters/model/CharacterClasses.ts";
import TagArrayInputField from "@/components/forms/TagArrayInputField.tsx";
import TextInputField from "@/components/forms/TextInputField.tsx";
import SelectInputField from "@/components/forms/SelectInputField.tsx";
import FormSection from "@/components/forms/FormSection.tsx";

export default function CharacterProfileForm() {

    return <FormSection title="Profil" contentClassName="grid gap-4 md:grid-cols-2 xl:grid-cols-4">

            <SelectInputField name="type" title="Monstertyp" options={MonsterType} nullable={true}/>
            <TextInputField name="race" title="Rasse"/>
            <TextInputField name="challenge" title="Level / HG" placeholder="z. B. 0,5 oder 10"/>
            <TextInputField name="xp" title="XP" placeholder="z. B. 200"/>

            <TagArrayInputField name="classes" title="Klassen" selectValues={CharacterClasses}
                                placeholder="Klasse hinzufügen" className="md:col-span-2 xl:col-span-4"/>
    </FormSection>;
}
